import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import Footer from "components/Footer";
import Navbar from "components/Navbar";
import Galeries from "components/detailsPage/Galeries";
import ProductAction from "components/detailsPage/ProductAction";
import ProductDescription from "components/detailsPage/ProductDescription";
import ProductTitle from "components/detailsPage/ProductTitle";

import { fetchData } from "store/actions/dataAction";
import { useParams } from "react-router";

function DetailsPage({ data, fetchData }) {
  const { user } = useSelector((state) => state.authReducer);

  const params = useParams();

  console.log(user);
  const breadcrumb = [
    {
      pageTitle: "Home",
      pageHref: user.role === "SELLER" ? "/seller" : "/",
    },
    { pageTitle: "Product Details", pageHref: "" },
  ];

  useEffect(() => {
    document.title = "Shoesnarian | Product Details";

    if (!data[params.id]) fetchData(`/product/${params.id}`, params.id);

    if (!data[`productSizes/${params.id}`])
      fetchData(`/size/${params.id}`, `productSizes/${params.id}`);
  }, [fetchData, data, params]);

  return (
    <>
      <Navbar />
      <ProductTitle breadcrumb={breadcrumb} data={data[params.id]} />
      <Galeries
        data={data[params.id]}
        size={data[`productSizes/${params.id}`]}
      />
      <section className="section-detail-product">
        <div className="container">
          <div className="row">
            <div className="col-7">
              <ProductDescription data={data[params.id]} />
            </div>
            <div className="col-5">
              <ProductAction data={data[params.id]} />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    data: state.data,
  };
};

export default connect(mapStateToProps, { fetchData })(DetailsPage);
